import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../grid-control.model';
@Pipe({
  name: 'commandDisabled'
})
export class CommandDisabledPipe implements PipeTransform {
  transform(disabled: boolean | ((item?: any) => boolean), item: GridItem): boolean {
    if (!disabled) {
      return false;
    }
    if (typeof (disabled) === 'boolean') {
      return disabled;
    }
    return disabled(item);
  }
}
